import React from "react";
import { ArrowLeft } from "lucide-react";
import Logo from "../../components/common/Logo"
import Topbar from "../../layout/TopBar";
import CommonHeader from "../../components/common/Commanheader";

function TermsOfUse() {
  return (
    <div className="min-h-screen bg-[#F4EFE8] px-4 md:px-10 py-6">

      {/* LOGO */}
      <div className="mb-8">
        <Logo />
      </div>



      {/* TOP BAR */}
      <div className="bg-primary rounded-md h-[70px] flex items-center justify-between px-6 md:px-8">

        <h2 className="text-white text-[24px] md:text-[40px] font-semibold">
          Terms of Use
        </h2>

        <button>
          <ArrowLeft
            size={40}
            className="text-white"
          />
        </button>

      </div>




      {/* CONTENT */}
      <div className="max-w-[1400px] mx-auto mt-16">

        {/* TITLE */}
        <div className="text-center">

          <h1 className="text-[#35223F] text-[35px] md:text-[40px] font-bold">
            Term of Use
          </h1>

          <p className="mt-5 text-[#7A6D79] text-[20px] md:text-[20px] max-w-[1000px] mx-auto leading-relaxed">
            Reference site about Lorem Ipsum, giving information on its origins,
            as well as a random.
          </p>

        </div>

        {/* DATE */}
        <div className="flex justify-end mt-20">

          <p className="text-[#202020] text-[22px] md:text-[20px] font-semibold">
            Effective date: August 1, 2021
          </p>

        </div>

        {/* INTRODUCTION */}
        <div className="mt-16">

          <h2 className="text-[#202020] text-[26px] md:text-[25px] font-bold uppercase mb-8">
            Introduction
          </h2>

          <p className="text-[#2D2D2D] text-[18px] md:text-[20px]  ">
            We are committed to respecting your online privacy and recognize
            your need for appropriate protection and management of any
            personally identifiable information (“Personal Information”) you
            share with us. “Personal Information” means any information that may
            be used, either alone or in combination with other information, to
            personally identify an individual, including, but not limited to, a
            first and last name, personal profile, a home or other physical
            address, an email address or other contact information.
          </p>

        </div>

        {/* SECTION 2 */}
        <div className="mt-20">

          <h2 className="text-[#202020] text-[26px] md:text-[25px] font-bold uppercase mb-8">
            User Responsibilities
          </h2>

          <p className="text-[#2D2D2D] text-[18px] md:text-[20px] ">
            Users are responsible for maintaining the confidentiality of their
            login credentials and ensuring that all activities performed through
            their account comply with platform policies. Misuse of the platform,
            unauthorized sharing of content, or disruptive behavior may lead to
            suspension or permanent termination of access.
          </p>

        </div>

        {/* SECTION 3 */}
        <div className="mt-20 mb-20">

          <h2 className="text-[#202020] text-[26px] md:text-[25px] font-bold uppercase mb-8">
            Privacy Policy
          </h2>

          <p className="text-[#2D2D2D] text-[18px] md:text-[20px] ">
            We value your privacy and take necessary steps to protect your
            personal information. Information collected through the platform is
            used solely for educational, analytical, and support purposes. We
            do not sell or distribute your data to third parties without your
            consent unless required by law.
          </p>

        </div>

      </div>

    </div>
  );
}

export default TermsOfUse;